import Component from '../inherited/Component';

export default class LoadMoreComp extends Component {
    constructor(elem, theme, options, ctx) {
        super(elem, theme, options, ctx);
    }

    mount() {
        $(this._elem).on('click', function () {
            let $this = $(this);
            let totalPages = parseInt($('[data-all-pages]').val());
            let currentPage = parseInt($('[data-this-page]').val());
            let datacollurl = $('[data-coll-url]').val();
            $this.attr('disabled', true);
            $this.find('[load-more-text]').addClass('hide');
            $this.find('[loader]').removeClass('hide');
            let nextUrl = $('[data-next-link]').val();
            let current_page_new = currentPage + 1;
            let next_coll = currentPage + 2;
            let product_per_page = $('[data-product-per-page]').val();
            let all_paginate_items = $('[data-all-paginate-items]').val();
            //alert(current_page_new)
            //return false;

            $.ajax({
                url: nextUrl,
                type: 'GET',
                dataType: 'html',
                success: function (responseHTML) {
                    $('[data-next-link]').val(
                        datacollurl + '?page=' + next_coll
                    );
                    $('[data-this-page]').val(current_page_new);
                    $('.product-grid').append(
                        $(responseHTML).find('.product-grid').html()
                    );

                    if (
                        product_per_page * current_page_new >
                        all_paginate_items
                    ) {
                        $('#viewed_items').text(all_paginate_items);
                    } else {
                        $('#viewed_items').text(
                            product_per_page * current_page_new
                        );
                    }
                },
                complete: function () {
                    if (current_page_new < totalPages) {
                        $this.attr('disabled', false);
                        $this.find('[load-more-text]').removeClass('hide');
                        $this.find('[loader]').addClass('hide');

                        var api = new Yotpo.API(yotpo);
                        api.refreshWidgets();
                    }
                    if (current_page_new >= totalPages) {
                        $this
                            .find('[load-more-text]')
                            .text('Products Finished')
                            .removeClass('hide');
                        $this.find('[loader]').addClass('hide');
                    }
                },
            });
        });

        // $('.js-load-more').on('click', function () {
        //     console.log('clicked component');
        //     let $this = $(this);
        //     let totalPages = parseInt($('[data-all-pages]').val());
        //     let currentPage = parseInt($('[data-this-page]').val());
        //     let datacollurl = $('[data-coll-url]').val();
        //     $this.attr('disabled', true);
        //     $this.find('[load-more-text]').addClass('hide');
        //     $this.find('[loader]').removeClass('hide');
        //     let nextUrl = $('[data-next-link]').val();
        //     let current_page_new = currentPage + 1;
        //     let next_coll = currentPage + 2;
        //     //alert(current_page_new)
        //     //return false;
        //     console.log('js-load-more', nextUrl);

        //     $.ajax({
        //         url: nextUrl,
        //         type: 'GET',
        //         dataType: 'html',
        //         success: function (responseHTML) {
        //             $('[data-next-link]').val(
        //                 datacollurl + '?page=' + next_coll
        //             );
        //             $('[data-this-page]').val(current_page_new);
        //             $('.product-grid').append(
        //                 $(responseHTML).find('.product-grid').html()
        //             );
        //         },
        //         complete: function () {
        //             if (current_page_new < totalPages) {
        //                 $this.attr('disabled', false);
        //                 $this.find('[load-more-text]').removeClass('hide');
        //                 $this.find('[loader]').addClass('hide');
        //             }
        //             if (current_page_new >= totalPages) {
        //                 $this
        //                     .find('[load-more-text]')
        //                     .text('Products Finished')
        //                     .removeClass('hide');
        //                 $this.find('[loader]').addClass('hide');
        //             }
        //         },
        //     });
        // });
    }
}
